import { useMemo as c } from "react";
import { sortRoutes as p } from "../components/Sidebar/helpers.js";
import { useSidebarSlot as a } from "./useSidebarSlot.js";
const d = (e) => {
  const r = e.filter((o) => o.display !== !1), i = r.length, {
    numberToDisplay: n
  } = a(i), t = p(r), s = c(() => t.slice(0, n ?? i), [e, n]), l = s.filter((o) => o?.position !== "bottom"), u = s.filter((o) => o?.position === "bottom"), m = t.slice(s.length, t.length);
  return {
    topRoutes: l,
    bottomRoutes: u,
    showMoreRoutes: m
  };
};
export {
  d as useSidebarRoutes
};
